import { render, staticRenderFns } from "./Recursos.vue?vue&type=template&id=4972f356&scoped=true"
import script from "./Recursos.vue?vue&type=script&lang=js"
export * from "./Recursos.vue?vue&type=script&lang=js"
import style0 from "./Recursos.vue?vue&type=style&index=0&id=4972f356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972f356",
  null
  
)

export default component.exports